import React from 'react';
import { TSelectValue } from 'components/Select/types';

interface IProps {
	value?: TSelectValue;
	onChange?: (value: TSelectValue) => void;
	children: (control: { value?: TSelectValue; onChange?: (value: TSelectValue) => void }) => React.ReactElement;
}

export const FormItemControl: React.FC<IProps> = ({ value, onChange, children }) => children({ value, onChange });
